import React from 'react';
import duraphat from '../images/Tabla/duraphat.png';

export default class Footer extends React.Component {


  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <header className='w-100'>
        <ul className="nav d-flex justify-content-center w-100">
          <li className="nav-item">
            <img src={duraphat} width="400" alt="Logo" className="imgheader" />
          </li>
        </ul>
      </header>
    );
  }
}